// ===========================
// XHR Intercept: Inject _selected_skus into add.js
// (same mechanism as expivi-custom-updated.js — without it, orders placed
// from this page carry no component SKUs at all)
// ===========================
(function () {
  var _lastSelectedSkus = '';
  // Snapshot of the settled preset selection — what the SumTracker bundle of
  // this product deducts natively. Sent as _preset_skus so the inventory Flow
  // can compute the delta (deduct what was selected, restock what the preset
  // had) without a metafield.
  var _presetBaselineSkus = null;

  window._etSnapshotBaselineSkus = function () {
    if (_presetBaselineSkus === null) {
      _presetBaselineSkus = _lastSelectedSkus;
      console.log('[ET] Preset baseline SKUs snapshotted.\n Selected SKUs:', _presetBaselineSkus);
    }
  };

  window._etUpdateSkus = async function () {
    if (!window.expivi) return;
    var attrs = await window.expivi.getProductAttributes();
    _lastSelectedSkus = attrs
      .filter(function (a) {
        return a.type === 'question' && a.visible !== false
          && a.attribute_values && a.attribute_values.length > 0;
      })
      .map(function (a) {
        const sel = a.attribute_values.find(v => v.id === a.selected_value_id);
        if (!sel?.key) return null;
        if (sel.key.startsWith('att-')) return null;
        return sel.key;
      })
      .filter(Boolean)
      .join(',');
  };

  window._etGetSelectedSkus = function () {
    return _lastSelectedSkus;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._etUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._etUrl && this._etUrl.indexOf('add.js') !== -1 && body) {
      try {
        var data = JSON.parse(body);
        if (!data.properties) data.properties = {};
        // _skus_v2 (NOT _selected_skus): the live Flow matches keys by the
        // substring "_selected_skus", so this name keeps test orders from this
        // theme invisible to it; the new v2 Flow triggers on _skus_v2 only.
        data.properties['_skus_v2'] = _lastSelectedSkus;
        data.properties['_preset_skus'] = _presetBaselineSkus || '';
        body = JSON.stringify(data);
        console.log('[ET] Injected into add.js — _skus_v2:', _lastSelectedSkus, '_preset_skus:', _presetBaselineSkus || '');
      } catch (e) {
        console.log('[ET] add.js body is not JSON, trying FormData');
      }
    }
    return origSend.call(this, body);
  };
})();

// ===========================
// Measurement Toggles
// ===========================
var measurementBottleSwitch = false;
var measurementCanSwitch = false;

// Toggle function for "Bottle"
function measurementBottleSwitcher() {
  measurementBottleSwitch = !measurementBottleSwitch;
  var bottleLink = document.getElementById('att-bottle');
  
  if (measurementBottleSwitch) {
    window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-yes');
    bottleLink.dataset.status = 'on';
    bottleLink.classList.add('ui-button-active');
  } else {
    window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-no');
    bottleLink.dataset.status = 'off';
    bottleLink.classList.remove('ui-button-active');
  }
}

// Toggle function for "Can"
function measurementCanSwitcher() {
  measurementCanSwitch = !measurementCanSwitch;
  var canLink = document.getElementById('att-can');
  
  if (measurementCanSwitch) {
    window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-yes');
    canLink.dataset.status = 'on';
    canLink.classList.add('ui-button-active');
  } else {
    window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-no');
    canLink.dataset.status = 'off';
    canLink.classList.remove('ui-button-active');
  }
}

// ===========================
// Main DOMContentLoaded Code
// ===========================
document.addEventListener('DOMContentLoaded', function() {

   console.log('[INIT] embedded-add-to-cart-btn found:', document.getElementById('embedded-add-to-cart-btn'));

  // --- Add to cart guard (per Expivi support) ---
  // Until the configurator has fully loaded and settled, the cached SKUs are
  // the catalogue defaults. Keep .expivi-add-to-cart disabled until
  // "fully_loaded" has fired and there were no further onChange events for
  // ET_SETTLE_MS, then re-read the SKUs and enable the button.
  var ET_SETTLE_MS = 800;
  var _etFullyLoaded = false;
  var _etSettled = false;
  var _etSettleTimer = null;

  var _etGuardStyle = document.createElement('style');
  _etGuardStyle.textContent = '.expivi-add-to-cart.expivi-atc-waiting{opacity:.5;cursor:not-allowed;}';
  document.head.appendChild(_etGuardStyle);

  function _etSetAtcDisabled(disabled) {
    document.querySelectorAll('.expivi-add-to-cart').forEach(function(btn) {
      btn.disabled = disabled;
      btn.classList.toggle('expivi-atc-waiting', disabled);
      btn.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  var _etAtcObserver = new MutationObserver(function() {
    if (!_etSettled) _etSetAtcDisabled(true);
  });

  function _etArmSettleTimer() {
    clearTimeout(_etSettleTimer);
    _etSettleTimer = setTimeout(function() {
      window._etUpdateSkus().then(function() {
        window._etSnapshotBaselineSkus();
        _etSettled = true;
        _etAtcObserver.disconnect();
        _etSetAtcDisabled(false);
        console.log('[ET] Configurator settled, add to cart enabled.\n Selected SKUs:', window._etGetSelectedSkus());
      });
    }, ET_SETTLE_MS);
  }

  _etSetAtcDisabled(true);
  _etAtcObserver.observe(document.body, { childList: true, subtree: true });

  setTimeout(function() {
    if (!_etSettled && !_etFullyLoaded) {
      console.warn('[ET] fully_loaded not seen after 20s, enabling add to cart anyway');
      _etArmSettleTimer();
    }
  }, 20000);

  // --- Keep _selected_skus updated ---
  if (window.expivi) {
    window.expivi._events.onReady.subscribe(function() {
      window._etUpdateSkus();
    });
    window.expivi._events.onChange.subscribe(function(e) {
      if (e.name === 'attribute' || e.name === 'buildupdated') {
        window._etUpdateSkus().then(function() {
          console.log('[ET] Selection changed (' + e.name + ')\n Selected SKUs:', window._etGetSelectedSkus());
        });
      }
      if (e.name !== 'frame') {
        if (e.name === 'fully_loaded') _etFullyLoaded = true;
        if (_etFullyLoaded && !_etSettled) _etArmSettleTimer();
      }
    });
  }

  // ----- Lightbox Configuration: Update Product Summary -----
  function updateProductSummary() {
    expivi.saveConfiguration().then((configData) => {
      var summaryDiv = document.getElementById('xpv-info-lightbox-content-1');
      var imageDiv = document.getElementById('xpv-info-lightbox-content-image');
      
      summaryDiv.innerHTML = '';
      imageDiv.innerHTML = '';

      var customParagraph = document.createElement('p');
      customParagraph.innerHTML = '<h3>Your Custom Bong!</h3>';
      summaryDiv.appendChild(customParagraph);
      
      var thumbnail = configData.configured_products[0].thumbnail;
      if (thumbnail) {
        var img = document.createElement('img');
        img.src = thumbnail;
        img.style.maxWidth = '100%';
        imageDiv.appendChild(img);
      }
      
      var ul = document.createElement('ul');
      configData.configured_products[0].attributes.forEach((a) => {
        var li = document.createElement('li');
        li.innerHTML = `<b>${a.attribute_name}:</b> ${a.attribute_value_name}`;
        ul.appendChild(li);
      });
      summaryDiv.appendChild(ul);

      var customDiv = document.createElement('p');
      customDiv.innerHTML = '';
      summaryDiv.appendChild(customDiv);
    }).catch(ex => { console.error(ex); });
  }

  // ----- Lightbox Show/Hide Functions -----
  function showLightbox() {
    document.getElementById('xpv-info-lightbox').style.display = 'flex';
  }

  function hideLightbox() {
    document.getElementById('xpv-info-lightbox').style.display = 'none';
  }

  // ----- Attach Lightbox Trigger Event Listeners -----
  var summaryButton1 = document.getElementById('summaryLightbox');
  if (summaryButton1) {
    summaryButton1.addEventListener('click', function(e) {
      e.preventDefault();
      updateProductSummary();
      showLightbox();
    });
  } else {
    console.error("Element with id 'summaryLightbox' not found.");
  }

  var summaryButton2 = document.getElementById('summaryLightbox2');
  if (summaryButton2) {
    summaryButton2.addEventListener('click', function(e) {
      e.preventDefault();
      updateProductSummary();
      showLightbox();
    });
  } else {
    console.error("Element with id 'summaryLightbox2' not found.");
  }

  // ----- Lightbox Close & Overlay Behavior -----
  var closeButton = document.getElementById('xpv-closeLightbox');
  if (closeButton) {
    closeButton.addEventListener('click', hideLightbox);
  }

  var lightboxOverlay = document.getElementById('xpv-info-lightbox');
  lightboxOverlay.addEventListener('click', function(e) {
    if (e.target === lightboxOverlay) {
      hideLightbox();
    }
  });

  // var lightboxContent = document.getElementById('xpv-info-lightbox-content');
  // lightboxContent.addEventListener('click', function(e) {
  //  e.stopPropagation();
  // });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      hideLightbox();
    }
  });

  // ----- Scroll to .ProductSummary on Info Icon Click -----
  var infoLink = document.querySelector('.expivi-info-panel-right #expivi-info-panel-image a');
  if (infoLink) {
    infoLink.addEventListener('click', function(e) {
      e.preventDefault();
      var productSummarySection = document.querySelector('.ProductSummary');
      if (productSummarySection) {
        productSummarySection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // ----- Fullscreen Toggle Styles -----
  const fullscreenButton = document.getElementById('button-fullscreen');
  if (fullscreenButton) {
    const fullscreenIcon = fullscreenButton.querySelector('i');
    let isFullscreen = false;

    fullscreenButton.addEventListener('click', function (e) {
      e.preventDefault();

      const viewer = document.querySelector('.expivi-viewer-container');
      const canvas = document.querySelector('#viewerContainer canvas');

      if (!viewer || !canvas) {
        console.warn('Viewer or canvas not found.');
        return;
      }

      viewer.style.transition = 'height 0.8s ease, z-index 0s';
      canvas.style.transition = 'transform 0.8s ease, margin-top 0.8s ease';

      if (!isFullscreen) {
        viewer.style.height = '80vh';
        viewer.style.zIndex = '1002';
        canvas.style.transform = 'scale(2)';
        canvas.style.marginTop = '100px';
        fullscreenIcon.classList.remove('fa-expand');
        fullscreenIcon.classList.add('fa-compress');
      } else {
        viewer.style.height = '';
        viewer.style.zIndex = '';
        canvas.style.transform = '';
        canvas.style.marginTop = '';
        fullscreenIcon.classList.remove('fa-compress');
        fullscreenIcon.classList.add('fa-expand');
      }

      isFullscreen = !isFullscreen;
    });
  } else {
    console.warn('#button-fullscreen not found.');
  }

  // ----- Measurement Toggles: Attach Listeners -----
  var bottleLink = document.getElementById('att-bottle');
  if (bottleLink) {
    bottleLink.addEventListener('click', function(e) {
      e.preventDefault();
      measurementBottleSwitcher();
    });
  }

  var canLink = document.getElementById('att-can');
  if (canLink) {
    canLink.addEventListener('click', function(e) {
      e.preventDefault();
      measurementCanSwitcher();
    });
  }

  // ----- Expand/Collapse #expivi-info-panel-button on #interactive-icon Click -----
  var icon = document.getElementById('interactive-icon');
  var panelButton = document.getElementById('expivi-info-panel-button');
  
  if (icon && panelButton) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
  
      if (panelButton.classList.contains('expanded')) {
        panelButton.style.width = "36px";
        setTimeout(() => panelButton.classList.remove('expanded'), 300);
      } else {
        panelButton.classList.add('expanded');
        panelButton.style.width = "180px";
      }
    });
  }

  // ----- "Add to Cart" in Lightbox: Show Spinner, Keep Default Behavior -----
var embeddedAddToCartBtn = document.getElementById('embedded-add-to-cart-btn');
if (embeddedAddToCartBtn) {
  embeddedAddToCartBtn.addEventListener('click', function() {
    console.log('[ATC] Button clicked');
    console.log('[ATC] data-product-id:', embeddedAddToCartBtn.dataset.productId);
    console.log('[ATC] data-url:', embeddedAddToCartBtn.dataset.url);
    console.log('[ATC] data-expivi-save:', embeddedAddToCartBtn.hasAttribute('data-expivi-save'));
    console.log('[ATC] window.expivi:', window.expivi);
    console.log('[ATC] window.expiviInstance:', window.expiviInstance);

embeddedAddToCartBtn.innerHTML = `<i class="fa-solid fa-spinner fa-spin"></i> Adding to cart...`;
console.log('[ATC] Spinner shown, Expivi data-expivi-save handler should now fire...');

    // Monitor XHR/fetch activity after click (wrap window.fetch only once —
    // wrapping on every click stacks the wrappers and duplicates the logs)
    if (!window._etFetchLogWrapped) {
      window._etFetchLogWrapped = true;
      var originalFetch = window.fetch;
      window.fetch = function(...args) {
        console.log('[ATC] fetch called with:', args[0]);
        return originalFetch.apply(this, args).then(res => {
          console.log('[ATC] fetch response status:', res.status, 'url:', args[0]);
          return res;
        }).catch(err => {
          console.error('[ATC] fetch error:', err);
          throw err;
        });
      };
    }
  });
}

  // ----- On "fully_loaded", retrieve attribute_value_name for 'att-bottle' and 'att-soda-can' -----
  window.expivi._events.onChange.subscribe(async function(e) {
    if (e.name === "fully_loaded") {
      try {
        const result = await window.expivi.saveConfiguration(0, 0, false, false, { include_keys: true });
        const attributes = result.configured_products[0].configuration.attributes;

        const bottleLink = document.getElementById('att-bottle');
        const canLink = document.getElementById('att-can');

        if (!bottleLink || !canLink) {
          console.warn("Bottle or Can links not found in the DOM.");
          return;
        }

        const bottleValue = attributes
          .filter(attr => attr.attribute_key === 'att-bottle')
          .map(attr => attr.attribute_value_name)[0];

        const canValue = attributes
          .filter(attr => attr.attribute_key === 'att-soda-can')
          .map(attr => attr.attribute_value_name)[0];

        if (bottleValue === 'Yes') {
          bottleLink.dataset.status = 'on';
          bottleLink.classList.add('ui-button-active');
          measurementBottleSwitch = true;
        } else {
          bottleLink.dataset.status = 'off';
          bottleLink.classList.remove('ui-button-active');
          measurementBottleSwitch = false;
        }

        if (canValue === 'Yes') {
          canLink.dataset.status = 'on';
          canLink.classList.add('ui-button-active');
          measurementCanSwitch = true;
        } else {
          canLink.dataset.status = 'off';
          canLink.classList.remove('ui-button-active');
          measurementCanSwitch = false;
        }

      } catch (ex) {
        console.error('Error retrieving attribute:', ex);
      }
    }
  });

});